export const getStringifiedQueryParams = (queryParams: object) =>
  new URLSearchParams(
    Object.entries(queryParams).map(([key, value]) => [key, String(value)]),
  ).toString();
